export const GET_PHOTOGRAPHERS_BY_REGION_SUCCESS = 'GET_PHOTOGRAPHERS_BY_REGION_SUCCESS';
export const GET_MULTIPLE_CALENDARS_SUCCESS = 'GET_MULTIPLE_CALENDARS_SUCCESS';

export const CREATE_PHOTOGRAPHER_CALENDAR_ITEM_SUCCESS =
    'CREATE_PHOTOGRAPHER_CALENDAR_ITEM_SUCCESS';
export const DELETE_PHOTOGRAPHER_CALENDAR_ITEM_SUCCESS =
    'DELETE_PHOTOGRAPHER_CALENDAR_ITEM_SUCCESS';
export const UPDATE_PHOTOGRAPHER_CALENDAR_ITEM_SUCCESS =
    'UPDATE_PHOTOGRAPHER_CALENDAR_ITEM_SUCCESS';

export const UPDATE_PHOTOGRAPHER_CALENDAR_WORKING_HOURS_SUCCESS =
    'UPDATE_PHOTOGRAPHER_CALENDAR_WORKING_HOURS_SUCCESS';
export const GET_SMS_TEMPLATES_FOR_PHOTOGRAPHER = 'GET_SMS_TEMPLATES_FOR_PHOTOGRAPHER';
export const GET_EMAIL_TEMPLATES_FOR_PHOTOGRAPHER = 'GET_EMAIL_TEMPLATES_FOR_PHOTOGRAPHER';
export const GET_EMAIL_SENDERS_FOR_PHOTOGRAPHER = 'GET_EMAIL_SENDERS_FOR_PHOTOGRAPHER';
